import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { switchMap, tap, withLatestFrom } from 'rxjs/operators';

import { AuthService } from '@auth/auth.service';
import { ApiPreloadCustomerLists } from '@data/store/data.actions';

import { environment } from '@environment';

import * as AuthActions from './auth.actions';
import { LoginInit, UpdateSessionData } from './auth.actions';
import * as authSelectors from './auth.selectors';

@Injectable()
export class AuthEffects {
  constructor(private actions$: Actions, private router: Router, private authService: AuthService, private store: Store) {}

  authLogin = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.LOGIN),
      withLatestFrom(
        this.store.select(authSelectors.selectScreens),
        this.store.select(authSelectors.selectIsRelogin),
        this.authService.changeCustomerOrFacilityPending$
      ),
      tap(([, screens, relogin, pending]) => {
        if (relogin && screens.currScreen && !pending) {
          this.router.navigate([screens.currScreen.route]);
        } else {
          this.router.navigate([environment.welcomeRoute]);
        }
      }),
      switchMap(([, , relogin]) => (relogin ? [new ApiPreloadCustomerLists()] : [new LoginInit(), new ApiPreloadCustomerLists()]))
    );
  });

  authLogout = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(AuthActions.LOGOUT),
        tap(() => {
          this.authService.logout();
          this.router.navigate(['/login']);
        })
      );
    },
    { dispatch: false }
  );

  authChangeCustomer = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.CHANGE_CUSTOMER),
      switchMap((data: any) => this.authService.changeCustomer(data.custid)),
      switchMap((action: any) => [new UpdateSessionData(action), new ApiPreloadCustomerLists()]),
      tap(() => {
        this.authService.changeCustomerOrFacilityPending$.next(false);
        this.router.navigate([environment.welcomeRoute]);
      })
    );
  });

  authChangeFacility = createEffect(() => {
    return this.actions$.pipe(
      ofType(AuthActions.CHANGE_FACILITY),
      switchMap((data: any) => this.authService.changeFacility(data.payload)),
      switchMap(() => [new ApiPreloadCustomerLists()]),
      tap(() => {
        this.authService.changeCustomerOrFacilityPending$.next(false);
        this.router.navigate([environment.welcomeRoute]);
      })
    );
  });
}
